import { render } from "./CompaniesFilter.vue?vue&type=template&id=1513619b&ts=true"
import script from "./CompaniesFilter.vue?vue&type=script&lang=ts"
export * from "./CompaniesFilter.vue?vue&type=script&lang=ts"

import "./CompaniesFilter.vue?vue&type=style&index=0&id=1513619b&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__